import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout/DashboardLayout';
import './ReportsPage.css';

const ReportsPage = () => {
    return (
        <DashboardLayout>
            <div className="reports-page">
                <h1>Reports</h1>
                <p>Reports functionality coming soon...</p>
            </div>
        </DashboardLayout>
    );
};

export default ReportsPage;